"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SensorPublished = void 0;

var react_1 = __importDefault(require("react"));

var ReactiveComponent_1 = __importDefault(require("@appbaseio/reactivesearch/lib/components/basic/ReactiveComponent"));

var hooks_1 = require("../../hooks");

var SensorPublished = function SensorPublished() {
  var flagsHook = (0, hooks_1.useFlags)();

  var _ref = (0, hooks_1.useReactifySearchContext)(),
      options = _ref.options;

  if (!flagsHook.flags["reactify-search:flag_sensor_published"]) {
    return null;
  }

  return react_1.default.createElement(ReactiveComponent_1.default, {
    componentId: "SensorPublished",
    customQuery: function customQuery() {
      if (options.market) {
        return {
          query: {
            bool: {
              must: [{
                match: {
                  markets: options.market
                }
              }, {
                match: {
                  published: true
                }
              }]
            }
          }
        };
      }

      return {
        query: {
          match: {
            published: true
          }
        }
      };
    }
  });
};

exports.SensorPublished = SensorPublished;